import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Table } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { PlusOutlined } from '@ant-design/icons';
import { getFarmAnimalList, doFarmAnimalDelete } from "../../../../redux/farmanimal/farmAnimalState";
import { handleTableChange, getAnimalTypeRoute } from "../../../../utils/index";

const RegisteredAnimalsTable = ({ recordList, pagination, doSearch, doDelete, animalTypeId, filters }) => {
  	const columns = [
		{
	        title: `Tag ID`,
	        dataIndex: 'tag_id',
	        key: 'tag_id',
	        width: '10%',
	        sorter: true,
	        render:(tag_id) => <span>{tag_id}</span>
	    },    
		{
	        title: `Breed`,
	        dataIndex: 'breed',
	        key: 'breed',
	        width: '10%',
	        render:(breed) => <span>{breed?.name}</span>
	    }, 
		{
	        title: `Gender`,
	        dataIndex: 'gender',
	        key: 'gender',
	        width: '10%',
	        render:(gender) => <span>{gender?.name}</span>
	    }, 
		{
	        title: `Sire ID`,
	        dataIndex: 'sire',
	        key: 'sire',
	        width: '10%',
	        render:(sire) => <span>{sire?.tag_id}</span>
	    },
		{
	        title: `Dam ID`,
	        dataIndex: 'dam',
	        key: 'dam',
	        width: '10%',
	        render:(dam) => <span>{dam?.tag_id}</span>
	    },	
		{
	        title: `DOB`,
	        dataIndex: 'date_of_birth',
	        key: 'date_of_birth',
	        width: '12%',
	        render:(date_of_birth) => <span>{date_of_birth}</span>
	    },
		{
	        title: `Farm Location`,
	        dataIndex: 'farm',
	        key: 'farm',
	        width: '25%',
	        sorter: true,
	        render:(farm) => <span>{farm?.name}</span>
	    },
	    {
	        title: <Button extra="btn-small">
			      		<a href={`/console/registered-animals/${getAnimalTypeRoute(animalTypeId)}/add`}>
					        <PlusOutlined />{' '}Add
					  	</a>
			    	</Button>,
	        dataIndex: 'id',
	        key: 'id',
	        width: '13%',
	        render:(id) => <CrudOption baseRoute={`/console/registered-animals/${getAnimalTypeRoute(animalTypeId)}`} recordId={id} deleteHandler={doDelete}/>
	    },
    ];
	
	useEffect(() => {
	    doSearch({paginate: pagination.per_page, type_id: animalTypeId});
    }, [doSearch, pagination.per_page]);

  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden mb-3">	      	
	      		<Table
		        	dataSource={recordList}
		        	columns={columns} 
		            rowKey={(record) => record.id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}
		            onChange={handleTableChange(doSearch, filters)}  
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.farmAnimal.recordList?.items,
	pagination: state.farmAnimal.recordList?.pagination,
	filters: state.farmAnimal.recordList?.filters,
  	requesting: state.farmAnimal.recordList?.requesting,
  	error: state.farmAnimal.recordList?.error,	  
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getFarmAnimalList(filters)),
  doDelete: (id) => dispatch(doFarmAnimalDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisteredAnimalsTable);